<template>
	<div>
		<div class="news-title" :style="{fontSize: details.titleSize ? details.titleSize : '18px'}">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				{{details.title}}
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="inner-content-1">
			<div v-html="details.txt">

			</div>
			<div class="back" @click="$router.back(-1)">
				返回列表
			</div>
		</div>
		<div v-if="likeGoodsList.length > 0">
			<div class="news-title" :style="{fontSize: details.titleSize ? details.titleSize : '18px'}">
				<i class="iconfont iconanchor-full"></i>
				<div style="margin: 0 20px;">
					其他课程
				</div>
				<i class="iconfont iconanchor-full"></i>
			</div>
			<div class="goods-list-main">
				<div class="goods-box" v-for="(item, index) in likeGoodsList" :key="index">
					<img :src="$imgUrl + item.listImgPc" alt="">
					<div class="goods-bottom">
						<div class="goods-bottom-left">
							<div class="goods-bottom-top">
								<div class="goods-bottom-top-left">
									{{item.title}}
								</div>
							</div>
							<div class="goods-bottom-bottom">
								<div>
									<i class="iconfont icondianzan" v-if="item.isLike == 'YES'">

									</i>
									<i class="iconfont icondianzan" v-else style="color: #B0B0B0;">

									</i>
									<span style="margin: 0 30px 0 10px;">
										{{item.likeNum}}
									</span>
								</div>
								<div>
									<i class="iconfont iconxihuan" v-if="item.isCollection == 'YES'">

									</i>
									<i class="iconfont iconxihuan" v-else style="color: #B0B0B0;">

									</i>
									<span style="margin: 0 30px 0 10px;">
										{{item.collectionNum}}
									</span>
								</div>
							</div>
						</div>
						<div class="goods-bottom-right" @click="changeId(item.id)">
							立即学习
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				lesson_id: "",
				details: {

				},
				likeGoodsList: []
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = ''
			that.lesson_id = this.$route.query.lesson_id
			that.getGoodsDetails()
			that.getLikeGoods()
		},
		methods: {
			changeId(lesson_id) {
				let that = this
				document.body.scrollTop = document.documentElement.scrollTop = 0
				that.lesson_id = lesson_id
				that.getGoodsDetails()
				that.getLikeGoods()
			},
			getLikeGoods() {
				let that = this
				that.$http.post({
					url: '/api/channel/findContentListByChannelId',
					data: {
						current: 1,
						size: 4,
						channelId: that.$store.state.channelId
					}
				}).then(res => {
					that.likeGoodsList = []
					if(res.code === 'S200') {
						res.data.content.forEach(item => {
							if(item.id != that.lesson_id && that.likeGoodsList.length < 3) {
								that.likeGoodsList.push(item)
							}
						})
					}
				})
			},
			getGoodsDetails() {
				let that = this
				that.$http.post({
					url: '/api/content/getContentById',
					data: {
						id: that.lesson_id
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.details = res.data
						if(that.details.txt) {
							that.format()
						}
					}
				})
			},
			backToList() {
				this.router.back(-1)
			},
			format() {
				var html = this.details.txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				this.details.txt = newContent
			},
			openLink() {
				if(this.details.outLink) {
					window.open(this.details.outLink);
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.goods-top {
		width: 1000px;
		display: flex;
		height: 365px;
		justify-content: space-between;
		margin: 10px auto;
		.goods-top-left {
			height: 365px;
			width: 600px;
			display: flex;
			flex-direction: column;
			.goods-top-left-top {
				width: 600px;
				height: 300px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.goods-top-left-bottom {
				margin-top: 3px;
				height: 55px;
				width: 110px;
				img {
					width: 100%;
					height: 100%;
					cursor: pointer;
				}
			}
		}
		.goods-top-right {
			height: 325px;
			width: 380px;
			border: 3px solid #EDD68E;
			padding: 20px;
			text-align: left;
			color: #686868;
			position: relative;
			.goods-top-right-content {
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				margin-top: 20px;
				-webkit-line-clamp: 4;
				line-clamp: 4;
				-webkit-box-orient: vertical;
			}
			.goods-top-right-icon {
				position: absolute;
				bottom: 80px;
				display: flex;
				height: 30px;
				line-height: 30px;
				margin-top: 5px;
				.iconfont {
					font-size: 20px;
					color: #922627;
				}
			}
			.goods-top-right-button {
				width: 260px;
				height: 42px;
				line-height: 42px;
				background-color: #264EA7;
				color: #FFFFFF;
				text-align: center;
				cursor: pointer;
				position: absolute;
				bottom: 20px;
			}
		}
	}
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		width: 1000px;
		margin: 10px auto;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
	.inner-content-1 {
		width: 1142px;
		margin: 30px auto 80px;
		font-size: 12px;
		color: #333333;
		text-align: left;
		padding: 0 20px;
		border-radius: 5px;
		.back {
			width: 75px;
			height: 20px;
			line-height: 20px;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			cursor: pointer;
			margin: 40px auto 20px;
		}
	}
	.goods-list-main {
		width: 1000px;
		margin: 20px auto 80px;
		display: flex;
		flex-wrap: wrap;
		.goods-box {
			width: 32%;
			margin: 10px 0.5%;
			height: auto;
			display: flex;
			flex-direction: column;
			img {
				width: 100%;
				height: 100%;
			}
			.goods-bottom {
				border: 3px solid #EDD68E;
				padding: 5px 15px;
				font-size: 13px;
				color: #686868;
				display: flex;
				position: relative;
				.goods-bottom-left {
					width: 70%;
					.goods-bottom-top {
						display: flex;
						height: 20px;
						line-height: 20px;
						justify-content: space-between;
						overflow: hidden;
						text-overflow: ellipsis;
						.goods-bottom-top-left {
							text-align: left;
						}
						.goods-bottom-top-right {
							width: 90px;
							background-color: #EDD68E;
							color: #FFFFFF;
							text-align: center;
						}
					}
					.goods-bottom-bottom {
						display: flex;
						height: 30px;
						line-height: 30px;
						margin-top: 5px;
						.iconfont {
							font-size: 20px;
							color: #922627;
						}
					}
				}
				.goods-bottom-right {
					position: absolute;
					bottom: 10px;
					height: 27px;
					line-height: 27px;
					width: 25%;
					background-color: #CDA63A;
					color: #FFFFFF;
					right: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/teaching_activities/dekt_details.vue